import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import { TabItemPropertyComponent } from './tab-item/tab-item-property.component';
import { TabsWrapperPropertyComponent } from './tabs-wrapper/tabs-wrapper-property.component';


@NgModule({
    imports: [
        BrowserModule,
    ],
    exports: [
        TabItemPropertyComponent,
        TabsWrapperPropertyComponent
    ],
    declarations: [
        TabItemPropertyComponent,
        TabsWrapperPropertyComponent
    ]
})
export class TabsPropertyModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/tabs/tabs-property.module.ts